module.exports = __webpack_public_path__ + "assets/icon-chat-bright-star-component.42249840.svg";